/** Sends the browser to Auth0 login, returning to `returnTo` (defaults to the current path) after sign-in. */
export function redirectToLogin(returnTo?: string): void {
  const loginUrl = new URL("/auth/login", window.location.origin);
  loginUrl.searchParams.set("returnTo", returnTo ?? window.location.pathname);
  window.location.assign(loginUrl.toString());
}
